/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import ISearchResultsApiClient from './contracts'
import { ISearchResultsList, ISearchResults, ISection, ISearchProducts } from '../SearchResultsStateManager/contracts'
import { injectProperty } from '../../configuration/ServiceLocator'
import { injectable } from 'inversify'
import { SearchResultQuery } from './SearchResultQuery'
import { IApiClient } from '../ApiClient/IApiClient'
import axios from 'axios'
import { SettingsManager } from '../../configuration/SettingsManager'
import { IUserSessionMiddleware } from '../middleware/UserSessionMiddleware/contracts'
import { ErrorHelper } from '../../utils/ErrorHelper'
import jwt_decode from 'jwt-decode'
import moment from 'moment'

@injectable()
export class SearchResultsApiClient implements ISearchResultsApiClient {
	@injectProperty('IApiClient')
	private readonly apiClient!: IApiClient

	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getSearchResults(searchTerm: string, perPage: number, skip: number): Promise<ISearchResultsList> {
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}`
		let prodList: string[] = [];
		let prodNamesList = [] as ISearchProducts[];
		this.apiClient.getCMSToken().then((token: string) => {
			let tokenObject: any = jwt_decode(token)
			tokenObject.AbilityProductCategoryClaimV2.productCategories.map((item: any, index: number) => {
				item.HomeIndexProductsViewModel.map((productItem: any, index: number) => {
					prodList.push(
						productItem.Code
					)
					prodNamesList.push({
						productCode: productItem.Code,
						productName: productItem.Name
					} as ISearchProducts
					)
				})
			})
		})
		return new Promise<ISearchResultsList>((resolve, reject) => {
			this.userSessionMiddleware.loadSessionJwt(false).then(x =>
				axios
					.post(url, {
						query: SearchResultQuery(),
						variables: { "parameters": JSON.stringify({ productList: prodList, filter: searchTerm, first: perPage, skip: skip }) },
					},
						{
							headers: {
								'Content-Type': 'application/json',
								Authorization: `Bearer ${x}`,
							},
						})
					.then((response: any) => {
						const formattedResults = { items: [], total: 0 } as ISearchResultsList
						if (response.data.data.myAbilityHelpSearchQuery.length > 0) {
							const data = response.data.data.myAbilityHelpSearchQuery
							data.map((item: any, index: number) => {
								const searchResult = {
									articleDescription: item.wysiwygContent.previewText,
									articleName: item.displayText,
									articlePath: item.path,
									articlePublishDate: moment(item.publishedUtc).format('LL'),
									productCode: item.productContent.productName,
									productName: prodNamesList[prodNamesList.findIndex(x => x.productCode == item.productContent.productName)].productName,
									sectionList: item.sectionTags != null ? this.getSectionForEachArticle(item.sectionTags) : []
								} as ISearchResults
								formattedResults.items.push(searchResult)
							})
							formattedResults.total = response.data.data.myAbilityHelpSearchQuery.length

						}
						else
							formattedResults.total = 0;
						resolve(formattedResults)
					})
					.catch((error: any) => {
						ErrorHelper.handleApiError(error)
						reject(error)
					})
			)
		})
	}

	getSectionForEachArticle(sections: any): ISection[] {
		let results = [] as ISection[]
		sections.termContentItems.map((section: any, sectionIndex: number) => {
			results.push({
				sectionId: section.contentItemId,
				sectionName: section.displayText
			} as ISection
			)
		})
		if (results.length != null)
			results.sort((a, b) => (a.sectionName.toLowerCase() < b.sectionName.toLowerCase() ? -1 : 1))
		return results
	}
}
